import { useState, createContext, useEffect } from 'react';
import { useSession } from 'next-auth/react';

import useAgentStore from 'src/hooks/UseStore';
import axios from 'axios';
import { requestLocationWithFallback } from 'src/utils/geolocation';
import { useVisitorData } from '@fingerprintjs/fingerprintjs-pro-react';
import { 
  isFingerprintCapturedThisSession, 
  setFingerprintCapturedThisSession
} from 'src/utils/fingerprint';
import { UAParser } from 'ua-parser-js';

export const SidebarContext = createContext({});

export function SidebarProvider({ children }) {

  const { data: session, status } = useSession();
  const { setAgentType } = useAgentStore();

  const [sidebarToggle, setSidebarToggle] = useState(false);
  const [idUsuario, setIdUsuario] = useState(null);

  const { data: fingerprintData, getData } = useVisitorData();

  const toggleSidebar = () => {
    setSidebarToggle(!sidebarToggle);
  };

  useEffect(() => {
    if (status === 'authenticated' && session?.user) {
      setAgentType(session.user);
      setIdUsuario(session.user.public_id);
    }
  }, [session, status]);


  useEffect(() => {
      if (idUsuario) {

        const createSessionWithLocation = async () => {
          
          try {
            const location = await requestLocationWithFallback();
            
            const ua = new UAParser(window.navigator.userAgent);
            const header = {
              browser: ua.getBrowser().name,
              os: ua.getOS().name,
              device: ua.getDevice().type,
              vendor: ua.getDevice().vendor,
              model: ua.getDevice().model,
            };

            // Get fingerprint data if available and not already captured
            let visitorId = null;
            if (!isFingerprintCapturedThisSession()) {
              getData({ linkedId: idUsuario }).then((data) => {
                if (data?.visitorId) {
                  console.log('captured');
                  visitorId = data.visitorId;
                  setFingerprintCapturedThisSession();
                }})
              console.log('Including fingerprint in session creation');
            }      
            await axios.post('/api/geolocation', { 
              id: idUsuario, 
              header,
              location,
              visitorId
            });
            
            console.log('Sesión creada con datos de ubicación');
            
          } catch (err) {
            console.warn('No se pudo obtener la ubicación, pero el login fue exitoso:', err);
            
            // Crear sesión sin datos de ubicación como fallback
            try {
              const ua = new UAParser(window.navigator.userAgent);
              const header = {
                browser: ua.getBrowser().name,
                os: ua.getOS().name,
                device: ua.getDevice().type,
                vendor: ua.getDevice().vendor,
                model: ua.getDevice().model,
              };
              // Get fingerprint data if available and not already captured
              let visitorId = null;
              if (!isFingerprintCapturedThisSession()) {
                getData({ linkedId: idUsuario }).then((data) => {
                  if (data?.visitorId) {
                    console.log('captured');
                    visitorId = data.visitorId;
                    setFingerprintCapturedThisSession();
                  }})
              }
      
              await axios.post('/api/geolocation', { 
                id: idUsuario, 
                header,
                location: null,
                visitorId
              });
              
              console.log('Sesión creada sin datos de ubicación');
              
            } catch (sessionErr) {
              console.error('Error al crear la sesión:', sessionErr);
            }
          }
        };

        createSessionWithLocation();
      }
  }, [idUsuario]);





  // useEffect(() => {
  //   if (idUsuario) {
  //     const createSessionWithLocation = async () => {

  //       try {
  //         const location = await requestLocationWithFallback();
          
  //         const ua = new UAParser(window.navigator.userAgent);
  //         const header = {
  //           browser: ua.getBrowser().name,
  //           os: ua.getOS().name,
  //           device: ua.getDevice().type,
  //           vendor: ua.getDevice().vendor,
  //           model: ua.getDevice().model,
  //         };

  //         // Get fingerprint data if available and not already captured
  //         let visitorId = null;
  //         if (!isFingerprintCapturedThisSession() && fingerprintData?.visitorId) {
  //           visitorId = fingerprintData.visitorId;
  //           setFingerprintCapturedThisSession();
  //           console.log('Including fingerprint in session creation');
  //         } else if (!fingerprintData?.visitorId) {
  //           // Try to get fingerprint data
  //           getData();
  //         }        
  //         await axios.post('/api/geolocation', { 
  //           id: idUsuario, 
  //           header,
  //           location,
  //           visitorId
  //         });
          
  //         console.log('Sesión creada con datos de ubicación');
          
  //       } catch (err) {
  //         console.warn('No se pudo obtener la ubicación, pero el login fue exitoso:', err);
          
  //         // Crear sesión sin datos de ubicación como fallback
  //         try {
  //           const ua = new UAParser(window.navigator.userAgent);
  //           const header = {
  //             browser: ua.getBrowser().name,
  //             os: ua.getOS().name,
  //             device: ua.getDevice().type,
  //             vendor: ua.getDevice().vendor,
  //             model: ua.getDevice().model,
  //           };
  //           // Get fingerprint data if available and not already captured
  //           let visitorId = null;
  //           if (!isFingerprintCapturedThisSession() && fingerprintData?.visitorId) {
  //             visitorId = fingerprintData.visitorId;
  //             setFingerprintCapturedThisSession();
  //             console.log('Including fingerprint in fallback session creation');
  //           }
    
  //           await axios.post('/api/geolocation', { 
  //             id: idUsuario, 
  //             header,
  //             location: null,
  //             visitorId
  //           });
            
  //           console.log('Sesión creada sin datos de ubicación');
            
  //         } catch (sessionErr) {
  //           console.error('Error al crear la sesión:', sessionErr);
  //         }
  //       }
  //     };
  //     createSessionWithLocation();
  //   }
  // }, [idUsuario, fingerprintData?.visitorId, getData]);

  const closeSidebar = () => {
    setSidebarToggle(false);
  };

  return (
    <SidebarContext.Provider value={{ sidebarToggle, toggleSidebar, closeSidebar }}>
      {children}
    </SidebarContext.Provider>
  );
}
